import { tv } from "../../variants/tv.js";
const mediaSnippetVariants = tv({
    slots: {
        rootSlot: '@container flex w-full flex-col text-left',
        mediaWrapperSlot: 'relative mb-3 w-full overflow-hidden rounded-xl transition-shadow group-hover:shadow-xl',
        mediaImageSlot: 'fill-mode-forwards absolute inset-0 h-full w-full',
        vignetteSlot: 'pointer-events-none absolute inset-0 h-full w-full shadow-[inset_0_0_80px_20px_oklch(from_var(--color-neutral-12)_l_c_h_/_0.15)]',
        mediaHeaderSlot: 'absolute inset-x-0 top-0 flex items-start justify-between gap-2 p-3',
        mediaHeaderLeftSlot: 'flex items-center',
        mediaHeaderRightSlot: 'flex items-center',
        scrimSlot: 'pointer-events-none absolute inset-x-0 bottom-0',
        captionSlot: 'font-bold text-primary-1 @2xs:text-heading4',
        headingSlot: 'mb-1 text-heading6 text-primary-13 @md:text-heading4',
        bodySlot: 'text-primary-13'
    }
});
export { mediaSnippetVariants };
